import LottiePlayer from 'lottie-web/build/player/lottie_light';
import AbstractComponent from './AbstractComponent';

class Lottie extends AbstractComponent {
  initializeBeforeEvents() {
    super.initializeBeforeEvents();

    this.isIntersecting = false;

    const { url } = this.ui.$element.dataset;

    fetch(url).then(res => res.json()).then(this.loadAnimation);
  }

  bind() {
    super.bind();
    this.loadAnimation = this.loadAnimation.bind(this);
  }

  loadAnimation(data) {
    const { loop = true } = this.ui.$element.dataset;

    this.animation = LottiePlayer.loadAnimation({
      container: this.ui.$element,
      renderer: 'svg',
      loop: Boolean(loop),
      autoplay: false,
      animationData: data
    });

    if (this.isIntersecting) {
      this.animation.play();
    }
  }

  handleIntersection([entry]) {
    if (entry.isIntersecting || entry.intersectionRatio > this.options.intersection.threshold) {
      this.animation?.play();
      this.isIntersecting = true;
    } else {
      this.animation?.pause();
      this.isIntersecting = false;
    }
  }
}

export default Lottie;
